import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { TbBattery4 } from 'react-icons/tb';
import { BiTimeFive } from 'react-icons/bi';
import { MetricIdEnum } from '../Metrics.model';

const useWidgetIconById = (id: MetricIdEnum) => {
  switch (id) {
    case MetricIdEnum.revenue:
      return <RiMoneyDollarCircleLine />;
    case MetricIdEnum.avgChargingSession:
      return <BiTimeFive />;
    case MetricIdEnum.energyDelivered:
      return <TbBattery4 />;
    case MetricIdEnum.totalChargingTime:
      return <BiTimeFive />;
    default:
      return <RiMoneyDollarCircleLine />;
  }
};

export default useWidgetIconById;
